import { createFileRoute } from "@tanstack/react-router";

import { AccountsPage } from "../../../features/payments/accounts-page";

export const Route = createFileRoute("/_app/payments/accounts")({ component: AccountsPage });
